import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { percentageScreenStyles as styles } from './components/AppStyles'; // Import the styles

const PercentageScreen = ({ route, navigation }) => {
  const { percentage, groupIndex, counter1, counter2 } = route.params;

  // Determine the font color based on the percentage
  const fontColor = percentage >= 70 ? '#41ad49' : '#d1444a';

  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: 'Score', // Set the header title to 'Score'
      headerLeft: null,
    });
  }, [navigation]);

  return (
    <View style={[styles.container, { backgroundColor: 'white' }]}>
      <Text style={[styles.headerText, { color: fontColor }]}>Deck {groupIndex + 1}</Text>
      <View style={styles.percentageContainer}>
        <Text style={[styles.percentageText, { color: fontColor }]}>Score: {percentage}%</Text>
      </View>
      <Text style={[styles.counterText, { color: fontColor }]}>Correct: {counter1}</Text>
      <Text style={[styles.counterText, { color: fontColor }]}>Incorrect: {counter2}</Text>
      <TouchableOpacity style={styles.returnButton} onPress={() => navigation.popToTop()}>
        <Text style={styles.returnButtonText}>Return to Home</Text>
      </TouchableOpacity>
    </View>
  );
};

export default PercentageScreen;